import React from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import ProgressBar from '../elements/ProgressBar'
import globals from '../globals'
import moment from 'moment'

const SpeedBoostUsageSummary = ({ serviceDetails, isLoaded }) => {
    const {
        boostBankMax,
        boostMonthDays,
        boostMonthMax,
        boostProgress,
        currentBoostEnds,
        boostStatus,
        boostBankDays,
        boostSpeed
    } = serviceDetails

    // Format the date.
    const formattedDate = moment(currentBoostEnds).format('HH:mm - DD MMM yyyy')

    // Calculate the percentage of the progressBar.
    const calculatePercentage = (firstNumber, secondNumber) => {
        if (secondNumber === 0) {
            return 0
        }
        return parseInt((firstNumber / secondNumber) * 100)
    }

    const isEnabled = () => {
        return boostStatus === 'Active'
    }

    return (
        <div className='my-usage module'>
            <Heading title='My Speed Boost Status' />
            <ModuleWithLoader isLoaded={isLoaded} className='p-4'>
                <div className='row'>
                    <div className='col-12 w-100 usage-wrapper'>
                        <div className='usage-current-container'>
                            <div className='d-flex usage-container bar-chart-wrapper'>
                                <div className={`usage-info-wrapper text-left ${isEnabled() ? 'active' : ''}`}>
                                    <img src='/images/taco.svg' alt='taco' />
                                    <div>
                                        <p className='m-0 bold pb-1 font-medium'>Speed Boost</p>
                                        <p className='m-0'>Status: {boostStatus}</p>
                                    </div>
                                </div>
                                <div className={`usage-info-wrapper text-left ${isEnabled() ? 'active' : ''}`}>
                                    <img src='/images/icon_plan.svg' alt='icon_plan' />
                                    <div>
                                        <p className='m-0 bold pb-1 font-medium'>Boost plan speed</p>
                                        <p className='m-0'>{boostSpeed}</p>
                                    </div>
                                </div>
                            </div>
                            {/* Remaining days for this months. */}
                            {
                                isEnabled() &&
                                <TitleProgressBar
                                    title='Current boost ends'
                                    statusText={formattedDate}
                                    progress={calculatePercentage(boostProgress, 100)}
                                    isDataBank
                                />
                            }

                            <TitleProgressBar
                                title='Free Upgrade Days remaining this month'
                                statusText={`${boostMonthDays} days`}
                                progress={calculatePercentage(boostMonthDays, boostMonthMax)}
                                isDataBank
                            />

                            <TitleProgressBar
                                title='My Boost Bank'
                                statusText={`${boostBankDays} days (${boostBankMax} max)`}
                                progress={calculatePercentage(
                                    boostBankDays,
                                    boostBankMax
                                )}
                                isDataBank
                            />

                            <p className='text-center lh'>
                                Your Speed Upgrade Days will be used up in the following order when you activate My Speed Boost.<br /><br className='d-lg-none' />
                                1st - FREE Speed Upgrade Days<br />
                                2nd - My Speed Upgrade Bank Days<br />
                                3rd - Purchased Upgrade Days
                            </p>
                        </div>
                    </div>
                </div>
            </ModuleWithLoader>
        </div>
    )
}

// Progressbar component for the speedboost page.
const TitleProgressBar = props => {
    return (
        <React.Fragment>
            <div className='bar-chart-wrapper'>
                <div className='row mb-2'>
                    <div className='col-6 col-lg-8 mb-1 mb-lg-0'>
                        <span className='bold'>{props.title}</span>
                    </div>
                    <div className='col-6 col-lg-4 text-right'>
                        <span>{props.statusText}</span>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12'>
                        <ProgressBar
                            progress={props.progress}
                            isDataBank={props.isDataBank}
                        />
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

SpeedBoostUsageSummary.propTypes = {
    serviceDetails: PropTypes.object.isRequired,
    isLoaded: PropTypes.bool
}

export default SpeedBoostUsageSummary



// WEBPACK FOOTER //
// ./resources/js/modules/SpeedBoostUsageSummary.js